import { ImageBanner } from '@ts-internal/shared-lib';
import { Box, Stack, Heading, Text } from 'braid-design-system';

import imageUrl from './images/market-image.jpg';

import { actionButtonStyle } from './NudgeBanner.css';

interface Props {
  actionButton: React.ReactNode;
  title: React.ReactNode | string;
  description: string;
}

export const NudgeBanner = ({ title, description, actionButton }: Props) => (
  <Box borderRadius={{ tablet: 'large' }} overflow="hidden">
    <ImageBanner imageUrl={imageUrl}>
      <Box maxWidth="xsmall" style={{ margin: 'auto' }}>
        <Stack space="large" align={{ mobile: 'center', desktop: 'left' }}>
          <Heading level="2">{title}</Heading>
          <Text>{description}</Text>
          <Box className={actionButtonStyle}>{actionButton}</Box>
        </Stack>
      </Box>
    </ImageBanner>
  </Box>
);
